import * as React from "react";
import './Step.css'

import Icon from "../../../../../components/Icon/Icon";
import FormInput from "../../../../../components/FormInput/FormInput";
import {InputTypes} from "../InputTypes";
import FormSelect from "../../../../../components/FormSelect/FormSelect";
import PlaidAuthenticator, {PlaidAuthenticationData} from "../../../../../components/PlaidAuthenticator/PlaidAuthenticator";
import FormButton from "../../../../../components/FormButton/FormButton";
import {observer} from "mobx-react";
import {FormComponent} from "../../../state/FormsState";
import PaymentFormContainer from "../../PaymentFormContainer/PaymentFormContainer";
import FormDropdown from "../../../../../components/FormDropdown/FormDropdown";
import {isMobile} from "react-device-detect";
import FormUtils from "../../../FormUtils";
import FormCalendar from "../../../../../components/FormCalendar/FormCalendar";
import MixPanelAnalyticsService from "../../../../../services/Analytics/MixPanelAnalyticsService";
import {AnalyticsSignUpEvents} from "../../../../../services/Analytics/AnalyticsSignUpEvents";
import CardsSelect from "../../../../../components/CardsSelect/CardsSelect";
import FormSelectButtons from "../../../../../components/FormSelectButtons/FormSelectButtons";
import {LeadPlanType} from "shared/functions/membersApi/types/ISignupProcess";
import FormMultipleSelect from "../../../../../components/FormMultipleSelect/FormMultipleSelect";
import ISelectOption from "../../../../../components/ComponentsTypes";
import PlacesAutoCompleteContainer from "src/scenes/Bots/Common/PlacesAutoComplete/PlacesAutoCompleteContainer";
import {IGooglePlace} from "shared/model/ICoworkGeoLocation";
import {SBAPages} from "../../../screens/FormSBA/FormSBASteps/SBATypes";
import FormFileInputContainer from "../../../../../components/FormFileInput/FormFileInputContainer";
import GoogleAnalyticsService from "../../../../../services/Analytics/GoogleAnalyticsService";
import {FileInputRenderingStatus} from "../../../../../components/FormFileInput/FileStatus";

interface ILocalState {
    renderPlaid: boolean;
    plaidError: boolean;
    plaidButtonText: string;
    success: boolean;
    isStepFinished:boolean;
    fileUploadSucceeded: boolean;
    filesAnimationController: any;
    isSelectedFromList : boolean
}

interface IOption {
    value: string | null;
    label: HTMLElement;
}

interface IProps {
    title: string;
    isPreviousStepFinished: boolean;
    updateNextStep: (nextIndex: number, val: boolean)=> void;
    cb: (params: any) => void;
    stepIndex: number;
    inputType: InputTypes;
    propertyName: string;
    formPageName: string;
    inputPlaceHolder?: string;
    subTitle?: string;
    isLast?: boolean;
    isFirst?: boolean;
    isHeader?: boolean;
    selectInputOptions?: any[];
    selectedOption?: any;
    allowSkip?: boolean;
    store?: any;
    customValidationCheck?: (value: any) => boolean;
    errorLabel?: string;
    dropdownOptions?: IOption[];
    isFormFinished: boolean;
    shortInput?: boolean;
    titleExplanationText?: string;
    isLocked?: boolean;
    onPlaceSelected?: (place: IGooglePlace | string) => void;
    updateSelectedPlace?: (placeInput: string) => void;
    specialTitleStyle?: any,
    secondSubTitle?: string,
    postFinishCB?: (inputValue: string) => Promise<any>
    maxChars?: number
}

@observer
export default class Step  extends React.Component<
    IProps,
    ILocalState
    > {
    public state: ILocalState = {
        renderPlaid: false,
        plaidError: false,
        plaidButtonText: "Connect",
        success: false,
        isStepFinished: false,
        fileUploadSucceeded: false,
        filesAnimationController: {},
        isSelectedFromList : false
    };

    public finishFormSteps = ["coverageContactEmail", "workspacePosition", "brokerPhoneNumber", "brokerClientDeposit"];

    public get inputValue() {
        const {store, formPageName, propertyName, inputType, selectedOption} = this.props;
        if(inputType === InputTypes.boolean) {
            return  selectedOption
        }
        if (store.formInput[formPageName][propertyName]) {
            const val = store.formInput[formPageName][propertyName];
            return inputType === InputTypes.amount? parseInt(val, 10).toLocaleString() : val;
        }
        return ""
    }

    public onInputChange = (value: string) => {
        const {propertyName, store, formPageName, inputType} = this.props;
        if (store.formInput && store.formInput[formPageName]) {
            store.formInput[formPageName][propertyName] = inputType === InputTypes.amount ? value.replace( /,/g, "" ) : value;
        }if(formPageName === SBAPages.loanCalculator) {
            store.reCalculateLoan(propertyName, formPageName, value)
        }
        if(propertyName === "userEmail" && !store.isEmailValid) {
            store.isEmailValid = true;
        }
        this.checkInputValidityAndUpdateStep();
    };

    public renderConnector = () => {
        const {isLast, isHeader, inputType, stepIndex, updateNextStep, customValidationCheck} = this.props;
        if(isHeader || inputType === InputTypes.nested) {
            return <div className="animated-connector"/>
        }
        else if (isLast) {
            return '';
        } else {
            if (FormUtils.validateInput(inputType, this.inputValue, customValidationCheck)) {
                if(!this.state.isStepFinished) {
                    this.setState({isStepFinished: true});
                }
                updateNextStep(stepIndex - 1, true);
            }else {
                if(this.state.isStepFinished) {
                    this.setState({isStepFinished: false});
                }
                updateNextStep(stepIndex - 1, false);
            }
            return this.state.isStepFinished ? <div className="animated-connector"/> : <div className="connector"/>;
        }
    };

    public checkInputValidityAndUpdateStep = () => {
        const {updateNextStep, stepIndex, inputType, propertyName, store, customValidationCheck} = this.props;
        if (FormUtils.validateInput(inputType, this.inputValue.trim(), customValidationCheck)) {
            this.finishStep();
        } else {
            this.setState({isStepFinished: false}, () => {
                updateNextStep(stepIndex - 1, false);
                if(propertyName === "coverageContactEmail") {
                    store.updateFinishForm(false);
                }
            });
        }
    };

    public finishStep = async (isSkipped?: boolean) => {
        const {updateNextStep, stepIndex, propertyName, store, formPageName, postFinishCB} = this.props;
        const newState = this.state;
        newState.isStepFinished = true;
        this.setState(newState);
        updateNextStep(stepIndex - 1, true);
        if(this.finishFormSteps.indexOf(propertyName) !== -1) {
            store.updateFinishForm(true);
        }
        if(propertyName === "plaidConnection") {
            store.updateBankDetails(false);
            store.updateCurrentComponent(FormComponent.verification);
        }
        if(propertyName === "depositAmount" && isSkipped) {
            store.showResetFormButton = false;
            store.formInput[formPageName][propertyName] = " ";
            store.updateFinance();
        }
        if(propertyName === "coveragePdfFile" && isSkipped) {
            store.formInput[formPageName][propertyName] = FileInputRenderingStatus.initial;
        }
        if(isSkipped === false) {
            this.setState({isStepFinished: false});
        }
        if (postFinishCB) {
            postFinishCB(store.formInput[formPageName][propertyName])
        }
    };

    public isInputDisabled = () => {
        const {isPreviousStepFinished, isFirst} = this.props;
        if(this.inputValue) {
            return false;
        }
        return !isPreviousStepFinished && !isFirst;
    };

    public getIconClass = () => {
        const {isFirst, isPreviousStepFinished} = this.props;
        let icon = '';
        if (isFirst) {
            icon = isMobile? "stepSmallFullMobile" : "stepSmallFull";
        } else {
            icon = isPreviousStepFinished ? "stepSmallFull" : "stepSmallEmpty";
            icon += isMobile? "Mobile": "";
        }
        return icon;
    };

    public renderIcon = () => {
        const {isHeader, isFormFinished} = this.props;
        let icon: any;
        if(isHeader) {
            const stepBigFinished  = <Icon icon={'stepBigFinished'}/>;
            const stepBigFull = <Icon icon={'stepBigFull'}/>;
            icon = isMobile? <div className="icon-container icon-container-header"><Icon icon={'stepBigFullMobile'}/></div> :
                <div className="icon-container icon-container-header">
                    {isFormFinished? stepBigFinished : null}
                    {isFormFinished? null : stepBigFull}
                </div>
        }else {
            icon = isHeader ?
                <div className="icon-container icon-container-header"><Icon icon={'stepBigFull'}/></div> :
                <div className="icon-container"><Icon icon={this.getIconClass()} /></div>;
        }
        return icon;
    }

    public renderProgressSection = () => {
        const connector = this.renderConnector();
        const icon = this.renderIcon();
        return (
            <div className="progress-section">
                {icon}
                {connector}
            </div>
        );
    };

    public openPlaid = () => {
        const {isPreviousStepFinished} = this.props;
        if(!isPreviousStepFinished) {
            return;
        }
        MixPanelAnalyticsService.track(AnalyticsSignUpEvents.OpenPlaid);
        GoogleAnalyticsService.triggerEvent("signup", "form submission", "financial details (open plaid)");
        const newState = this.state;
        newState.renderPlaid = true;
        newState.plaidButtonText = "Connecting";
        window.scrollTo(0,0);
        this.setState(newState);

    };

    public focusOut= () => {
        if(!this.inputValue) {
            return;
        }
        const {store, propertyName, formPageName} = this.props;
        FormUtils.updateAnalytics(propertyName, store, formPageName);
        switch (propertyName) {
            case "amount": {
                if(store.formInput.plans.plansValue === LeadPlanType.Deposit) {
                    store.updateFinance();
                }
                break;
            }
        }
        if(propertyName === "userEmail" &&  FormUtils.validateEmailChars(this.inputValue) && store.registeredMailAddress !== this.inputValue) {
            this.finishStep();
            store.createNeUser();
        }
    };

    public finishStepAndRunCB = (val: any) => {
        const {cb, propertyName, inputType, updateNextStep, stepIndex} = this.props;
        if(inputType === InputTypes.dropdown && !val) {
            updateNextStep(stepIndex - 1, false);
            return;
        }
        this.finishStep();
        if(cb) {
            if(propertyName === "signupPdfFile") {
                const newState = this.state;
                newState.isStepFinished = false;
                this.setState(newState);
            }
            cb(val);
        }
    };

    public getPlaidButtonClasses = () => {
        const {isPreviousStepFinished} = this.props;
        if(isPreviousStepFinished) {
            if(this.state.plaidButtonText === "Connecting") {
                return "yellow loading";
            }else {
                return "yellow"
            }
        }else {
            return "disabled"
        }
    };

    public renderCTA = () => {
        const {inputPlaceHolder, propertyName, inputType, selectInputOptions, selectedOption, isPreviousStepFinished, store,
             dropdownOptions, cb, stepIndex, updateNextStep, formPageName} = this.props;
        switch (inputType) {
            case InputTypes.phoneNumber:
            case InputTypes.number:
            case InputTypes.amount:
            case InputTypes.email:
            case InputTypes.text: return this.renderFormInput();
            case InputTypes.button: {
                const btnClass = this.getPlaidButtonClasses();
                return (<div className="plaid-btn">
                    <FormButton isLoading={this.state.plaidButtonText === "Connecting" && !store.plaidError} btnText={this.state.plaidButtonText} classes={btnClass} click={this.openPlaid}/>
                </div>);
            }
            case InputTypes.file: {
                return (<>
                    <FormFileInputContainer store={store} cb={cb} propertyName={propertyName} stepIndex={stepIndex} formPageName={formPageName} updateNextStep={updateNextStep} fileStoreValue={this.inputValue}/>
                </>)
            }
            case InputTypes.paymentForm: {
                // return <PaymentFormContainer store={store}/>
                return <PaymentFormContainer store={store} isPaymentErrorFound={store.isPaymentError}/>
            }
            case InputTypes.dropdown: {
                return <FormDropdown placeholder={selectedOption || inputPlaceHolder || "Choose your answer"} options={dropdownOptions} selectCB={this.finishStepAndRunCB} isDisabled={this.isInputDisabled()} initialValue={selectedOption} />;
            }
            case InputTypes.calendar:
                return <FormCalendar store={store} onDateSelected={this.finishStepAndRunCB}/>;
            case InputTypes.boolean:
                return <div className="select-box">
                    <FormSelect isDisabled={!isPreviousStepFinished} propName={propertyName} selectedOption={selectedOption} options={selectInputOptions}/>
                </div>;
            case InputTypes.cardsSelect:
                if(selectInputOptions) {
                    return <div className="cards-select-container"> <CardsSelect cardsValues={selectInputOptions}/> </div>
                };
                return false;
            case InputTypes.multipleSelect:
                if(selectInputOptions) {
                    return <div className={"multi-button-select-box" + (isMobile? " select-box-mobile": "")}>
                        <FormSelectButtons isDisabled={!isPreviousStepFinished} options={selectInputOptions}/>
                    </div>;
                }
                return false;
            case InputTypes.multipleCheckSelect: {
                return <FormMultipleSelect
                    isDisabled={!isPreviousStepFinished}
                    finishStepInFormCB={this.finishStep}
                    getSelectedValues={selectedOption}
                    selectOptions={selectInputOptions as ISelectOption[]} />
            }
            case InputTypes.locationSearch:{
                return <PlacesAutoCompleteContainer placeholder={"43W 23rd St, New York, NY 10010"}
                                                    inputLabel={""}
                                                    navigationProperty={propertyName}
                                                    initialValue={""}
                                                    updateStore={this.updateSelectedPlace} onPlaceSelected={this.selectPlace}
                                                    autoFocus={false}
                                                    generalSearch={true}/>
            }
            case InputTypes.nested: {
                return null;
            }
            default: return null
        }
    };

    public renderFormInput = () => {
        const {inputPlaceHolder, errorLabel, isLocked, inputType, maxChars, customValidationCheck} = this.props;
        return <FormInput
            change={this.onInputChange}
            val={this.inputValue}
            maxChars={maxChars}
            onFocusOut={this.focusOut}
            showError={this.inputValue.length > 0 && customValidationCheck && !customValidationCheck(this.inputValue)}
            errorLabel={errorLabel}
            isLocked={isLocked}
            placeholder={inputPlaceHolder}
            isDisabled={this.isInputDisabled()}
            isAmount={inputType === InputTypes.amount}
            isNumber={inputType === InputTypes.number}
            isPhoneNumber={inputType === InputTypes.phoneNumber}
        />
    };

    public selectPlace = (place: IGooglePlace | string) => {
        const {store, formPageName, propertyName} = this.props;
        store.setSearchLocationResult(propertyName, place, formPageName);
        this.setState({isSelectedFromList:true});
    };

    public updateSelectedPlace = (searchQuery: string) => {
        this.onInputChange(searchQuery);
    };

    public renderSkip = () => {
        const {allowSkip, propertyName, store, formPageName} = this.props;
        let skipText = '';
        switch (propertyName) {
            case "contactEmail":
            case "coveragePdfFile":
            case "coverageContactEmail":
                skipText = "Skip";
                break;
            case "signupPdfFile":
                if(!store.formInput[formPageName][propertyName]) {
                    skipText = "Cancel";
                }
                break;
            default: skipText = "Skip for now";
        }
        return allowSkip && !(store.formInput[formPageName][propertyName]) ? <div className={"skip"} onClick={this.skipStep}>{skipText}</div> : null;
    };

    public skipStep = () => {
        const {isPreviousStepFinished, store, formPageName, propertyName, inputType} = this.props;
        if(!isPreviousStepFinished) {
            return;
        }
        FormUtils.updateAnalytics(propertyName, store, formPageName);
        if(propertyName === "amount" && store.formInput.plans.plansValue === LeadPlanType.Deposit) {
            store.updateFinance()
        }
        if(inputType === InputTypes.file) {
         store.formInput[formPageName][propertyName] = " ";
        }
        this.finishStep(true);
    };

    public renderStepContent = () => {
        const stepTitle = this.renderStepTitle();
        const stepContent = this.renderStepCTA();
        return (
            <div className="step-content">
                {stepTitle}
                {stepContent}
            </div>
        );
    };

    public renderStepTitle = () => {
        const {subTitle, isHeader, propertyName, formPageName, titleExplanationText, specialTitleStyle, secondSubTitle} = this.props;
        let {title} = this.props;
        let titleClass = isHeader ? "step-title-header" : "step-title";
        if(propertyName === "plaidConnection" && this.state.plaidError) {
            titleClass = "step-title-error";
            title = "Connect your bank account to continue";
            if(this.state.plaidButtonText !== "Connect") {
                const newState = this.state;
                newState.plaidButtonText = "Connect";
                this.setState(newState);
            }
        }
        const cardTitle =  <div className={titleClass} style={specialTitleStyle}>{title}</div>;
        const upgradePageSubTittleClass =   formPageName === "upgrade"?' upgrade-sub-title': '';
        const cardSubTitle = subTitle? <div className={"sub-title" + upgradePageSubTittleClass}>{subTitle}</div>: null;
        const titleExplanation = titleExplanationText? <div className={"sub-title-explanation" + upgradePageSubTittleClass}>{titleExplanationText}</div>: null;
        const secSubTitle = secondSubTitle? <div className={"sub-title-explanation"}>{secondSubTitle}</div>: null;
        return (<>
            {cardTitle}
            {cardSubTitle}
            {secSubTitle}
            {titleExplanation}
        </>)
    };

    public renderStepCTA = () => {
        const {isHeader, allowSkip, shortInput} = this.props;
        let ctaClasses = allowSkip? "step-cta-skip" : "step-cta";
        const skipClasses =  shortInput? ' short-input' : '';
        ctaClasses += skipClasses;
        return isHeader ? null :
            <div className={ctaClasses}>
                <div className="cta-container">
                    {this.renderCTA()}
                </div>
                {this.renderSkip()}
            </div>;
    }

    public render() {
        const {renderPlaid} = this.state;
        const {isHeader} = this.props;
        const containerClass = isHeader ? "step-container header" : "step-container";
        return (
            <div className={containerClass}>
                {this.renderProgressSection()}
                {this.renderStepContent()}
                {renderPlaid ? <PlaidAuthenticator onConnectExit={this.closePlaid} onAuthenticationFinished={this.onAuthenticationFinished}/> : null}
            </div>
        );
    };

    private closePlaid = () => {
        MixPanelAnalyticsService.track(AnalyticsSignUpEvents.ExitPlaid);
        const newState = this.state;
        newState.plaidButtonText = "Connect";
        newState.renderPlaid = false;
        newState.plaidError = true;
        this.setState(newState);
    };

    private onAuthenticationFinished = (succeeded: boolean, data?: PlaidAuthenticationData) => {
        const {store, propertyName} = this.props;
        const newState = this.state;
        newState.plaidButtonText = "Connect";
        this.setState(newState);
        if (succeeded && data) {
            MixPanelAnalyticsService.track(AnalyticsSignUpEvents.PlaidGood);
            GoogleAnalyticsService.triggerEvent("signup", "plaid window closed", "plaid closed");
            this.setState({success: succeeded, renderPlaid: false});
            if(store.uid) {
                store.updateBankDetails(data, propertyName);
            }else {
                store.storeAccountDetails(data)
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/scenes/Forms/components/FormStepper/Step/Step.tsx